(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('appointmentType', [AppointmentTypeDirectiveFn]);

    // appointment type directive
    function AppointmentTypeDirectiveFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/agendasettings/modules/appointmenttypes/templates/appointment-type.template.html',
            controller: 'AppointmentTypeController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                type: '=',
                overview: '='
            }
        };
        return directive;

    }

})();